// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lUi2","toggle":"styles_toggle__3yqgJ","preview":"styles_preview__woh3f"};